// extracted by mini-css-extract-plugin
export default {"content":"kqd6JNuF","actions":"EeRcdsmN","title":"nHsFv0Rn","button":"KxkH5IFl"};